module.exports = __webpack_public_path__ + "img/5.195202cf.jpg";